export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["From"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amount"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfer"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfer between own accounts"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfers within wallet"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account of the sender and the recipient must be different"])}
}